import { fetchExhibitions } from '@/services/sheets'

export default {
    namespaced: true,

    state: () => ({
        items: [],
        loading: false,
        loaded: false,
    }),

    getters: {
        all: state => state.items,
        current: state => state.items.filter(e => e.status === 'current'),
        past: state => state.items.filter(e => e.status === 'past'),
        pastPersonal: state => state.items.filter(e => e.status === 'past' && e.type === 'personal'),
        pastGroup: state => state.items.filter(e => e.status === 'past' && e.type === 'group'),
    },

    mutations: {
        SET_ITEMS(state, items) { state.items = items },
        SET_LOADING(state, val) { state.loading = val },
        SET_LOADED(state, val) { state.loaded = val },
    },

    actions: {
        async fetch({ commit, state }) {
            if (state.loaded) return
            commit('SET_LOADING', true)
            try {
                const data = await fetchExhibitions()
                commit('SET_ITEMS', data)
                commit('SET_LOADED', true)
            } catch (e) {
                console.error('[Store:exhibitions]', e)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}
